import { render } from "./AiOpsLab.vue?vue&type=template&id=3e0e10b6&scoped=true"
import script from "./AiOpsLab.vue?vue&type=script&lang=js"
export * from "./AiOpsLab.vue?vue&type=script&lang=js"

import "./AiOpsLab.vue?vue&type=style&index=0&id=3e0e10b6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e0e10b6"]])

export default __exports__